import { render, staticRenderFns } from "./menu-chart.vue?vue&type=template&id=9d4c26b8&"
import script from "./menu-chart.vue?vue&type=script&lang=js&"
export * from "./menu-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports